import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        // You can log the error to an error reporting service here
        console.error(error, info);
    }

    render() {
        if (this.state.hasError) {
            return <div>Oops! Something went wrong.</div>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;